import { BrowserModule } from "@angular/platform-browser";
import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
  MsalModule,
  MsalRedirectComponent
} from "@azure/msal-angular";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { HeaderComponent } from "./shared/header/header.component";
import { TestslipsComponent } from "./work-review/testslips/testslips.component";
import { SearchComponent } from "./work-review/search/search.component";
import { DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSelectModule } from "@angular/material/select";
import { MaterialModule } from "src/app/core/modules/material.module";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTreeModule } from "@angular/material/tree";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { SideNavComponent } from "./shared/side-nav/side-nav.component";
import { AlertDialogComponent } from "src/app/shared/alert-dialog/alert-dialog.component";
import { ViewTestslipsComponent } from "./work-review/view-testslips/view-testslips.component";
import { MatDialogModule } from "@angular/material/dialog";
import { LightboxModule } from "ngx-lightbox";
import { ModalComponent } from "./shared/modal/modal.component";
import { UserRegionComponent } from "./shared/user-region/user-region.component";
import { SafePipe } from "./pipes/safe.pipe";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NotificationsComponent } from "./notifications/notifications/notifications.component";
import { AddNotificationsComponent } from "./notifications/add-notifications/add-notifications.component";
import { QuillModule } from "ngx-quill";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { DigitalWireCountComponent } from "./components/digital-wire-count/digital-wire-count.component";
import { WireCountDataComponent } from "./components/wire-count-data/wire-count-data.component";
import { PermutationChartComponent } from "./components/permutation-chart/permutation-chart.component";
import { AppService } from "./services/app.service";
import { environment } from "src/environments/environment";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { MatPaginatorModule } from "@angular/material/paginator";
import {MatChipsModule} from '@angular/material/chips';
import { SharedModule } from "src/app/shared/shared.module";
import { AuthenticationModule } from "./core/authentication/authentication.module";
import { UnAuthorizedComponent } from "./components/un-authorized/un-authorized.component";
import { AddOfflineTestslipComponent } from './work-review/add-offline-testslip/add-offline-testslip.component';

export function initializerFactory(appService: AppService): any {
  const promise = appService.load().then(() => {});
  return () => promise;
}

// export const protectedResourceMap: [string, string[]][] = [
//   ["/smthapi/", [environment.API]],
// ];

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        HeaderComponent,
        TestslipsComponent,
        SearchComponent,
        SideNavComponent,
        ViewTestslipsComponent,
        AlertDialogComponent,
        ModalComponent,
        UserRegionComponent,
        SafePipe,
        NotificationsComponent,
        AddNotificationsComponent,
        PageNotFoundComponent,
        DigitalWireCountComponent,
        WireCountDataComponent,
        PermutationChartComponent,
        DateFormatPipe,
        UnAuthorizedComponent,
        AddOfflineTestslipComponent,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [FormsModule,
        ReactiveFormsModule,
        MatTabsModule,
        BrowserAnimationsModule,
        QuillModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        MsalModule,
        BrowserModule,
        MatAutocompleteModule,
        MaterialModule,
        MatSidenavModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTreeModule,
        SharedModule,
        MatPaginatorModule,
        MatSnackBarModule,
        // ScrollingModule,
        AppRoutingModule,
        AuthenticationModule,
        MatDialogModule,
        MatChipsModule,
        LightboxModule,
        NgxMaterialTimepickerModule,
        NgMultiSelectDropDownModule.forRoot()], providers: [
        DatePipe,
        AppService,
        provideAppInitializer(() => {
        const initializerFn = (initializerFactory)(inject(AppService));
        return initializerFn();
      }),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
